import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Admin Service
 * Handles all admin-related API calls
 */
const adminService = {
  // Auth
  login: async (credentials) => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response.data;
  },

  // Notification
  addNotificationToken: async (token) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.ADD_NOTIFICATION_TOKEN, { token });
    return response.data;
  },

  // Razorpay
  getAllRazorpay: async () => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.GET_ALL_REZARPAY);
    return response.data;
  },

  updateRazorpay: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.UPDATE_REZARPAY, data);
    return response.data;
  },

  addRazorpay: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.ADD_REZARPAY, data);
    return response.data;
  },

  // Vender Management
  getAllVender: async () => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.GET_ALL_VENDER);
    return response.data;
  },

  getAllPendingVender: async () => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.GET_ALL_PENDING_VENDER);
    return response.data;
  },

  deleteVender: async (vendorId) => {
    const response = await apiClient.delete(API_ENDPOINTS.ADMIN.DELETE_VENDER, {
      data: { vendorId },
    });
    return response.data;
  },

  getAllVerifiedVender: async () => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.ALL_VERIFIED_VENDER);
    return response.data;
  },

  updateVenderAssenWork: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.UPDATE_VENDER_ASSEN_WORK, data);
    return response.data;
  },

  updateVenderDetails: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.UPDATE_VENDER_DETAILS, data);
    return response.data;
  },

  getRegistrationSetting: async () => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.GET_REGISTRATION_SETTING, {});
    return response.data;
  },

  setGstEnabled: async (gstEnabled) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.SET_GST_ENABLED, { gstEnabled });
    return response.data;
  },

  updateVenderRegistration: async (data) => {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.UPDATE_VENDER_REGISTRATION, data, isFormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined);
    return response.data;
  },

  approveVender: async (venderId, adminId) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.APPROVE_VENDER, { venderId, adminId });
    return response.data;
  },

  // User Job Cart
  updateUserJobCartApproved: async (bookingId) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.UPDATE_USER_JOB_CART_APPROVED, {
      bookingId,
    });
    return response.data;
  },

  getUserMembership: async (userId) => {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.GET_USER_MEMBERSHIP, { userId });
    return response.data;
  },
};

export default adminService;

